module.exports = __webpack_public_path__ + "static/hero-b150075d89a7135dbe5631c7a5994154.png";